<div class="card">
	<div class="title">{{"site.battery_performance_metrics" | translate}}</div>
	<ng-container *ngFor="let data of batteryPerformanceMetrics">
		<div class="content">
			<div class="left-side">
				<mat-icon [class]="'icon-' + data.color">{{ data.icon }}</mat-icon>
				<span class="label">{{ data.label }}</span>
			</div>
				<span class="performance-values">{{ data.value }}%</span>
		</div>
	</ng-container>
</div>

<div class="card mt-4" *ngIf="siteChargingType != ChargingType.CONVENTIONAL">
	<div class="title">{{"site.opportunity_fast_charging_metrics" | translate}}</div>
	<ng-container *ngFor="let data of chargingMetrics">
		<div class="metric-container">
			<div class="header">
				<span class="label">{{ data.label }} {{ data.siteValue }}</span>
				<span class="value">{{ data.value }}%</span>
			</div>
  
			<div class="progress-bg">
				<div class="progress-fill" [style.width.%]="data.value > 100 ? 100 : data.value"></div>
			</div>
		</div>
	</ng-container>
</div>